import { render, staticRenderFns } from "./LassoxLink.vue?vue&type=template&id=3daa309e"
import script from "./LassoxLink.vue?vue&type=script&lang=ts"
export * from "./LassoxLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports